$(document).ready(function () {
      $("p.shopify_subscriptions_app_policy").replaceWith('<p class="shopify_subscriptions_app_policy">Auto-renews. Modify or cancel anytime.</p>');


//   document.querySelectorAll('div#ASmlub0RLcmh0NnRUM__subscriptions_app_block_Hr9fQR_1f91cf81fc419f9c75dcead738433044e07ddef3_46983804944690_allocation_price').forEach(div => {
//   div.textContent = div.textContent.slice(0, -3);
// });
  // Using plain JavaScript
document.querySelectorAll('.shopify_subscriptions_in_widget_price, [data-variant-price], [aria-label*="USD"]').forEach(element => {
    // For elements with text content (like price divs)
    if (element.textContent) {
        element.textContent = element.textContent.replace(' USD', '');
    }
    
    // For elements with data-variant-price attribute
    if (element.hasAttribute('data-variant-price')) {
        const price = element.getAttribute('data-variant-price');
        element.setAttribute('data-variant-price', price.replace(' USD', ''));
    }
    
    // For elements with aria-label attribute
    if (element.hasAttribute('aria-label')) {
        const label = element.getAttribute('aria-label');
        element.setAttribute('aria-label', label.replace(' USD', ''));
    }
});

// Also handle data-variant-compare-at-price
document.querySelectorAll('[data-variant-compare-at-price]').forEach(element => {
    const price = element.getAttribute('data-variant-compare-at-price');
    if (price && price.includes('USD')) {
        element.setAttribute('data-variant-compare-at-price', price.replace(' USD', ''));
    }
});

    });

//   $(window).on('scroll', function () {
//     if ($(window).scrollTop() > 20) {
//       $('sticky-header.header-wrapper').addClass('header_scrolled');
//     } else {
//       $('sticky-header.header-wrapper').removeClass('header_scrolled');
//     }
//   });
// $(document).ready(function () {
//   const currentUrl = window.location.href.trim();
//   const isHomepage = currentUrl === 'https://datefix.com/' || currentUrl === 'https://datefix.com';

//   if (isHomepage) {
//     // Add class to enable special homepage styles
//     $('body').addClass('datefix-homepage');

//     // Preload images
//     $('<img>').attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/cart.svg?v=1757422731');
//     $('<img>').attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/cart_dark.svg?v=1757422730');
//     $('<img>').attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo.svg?v=1757364310');
//     $('<img>').attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo_dark.svg?v=1757364610');

//     const $header = $('sticky-header.header-wrapper');
//     const $logo = $('.header__heading-logo-wrapper img');
//     const $cart = $('.header__icon--cart img');

//     // Force light logo on homepage load (transparent header)
//     $logo.attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo.svg?v=1757364310');
//     $logo.attr('srcset', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo.svg?v=1757364310');
//     $cart.attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/cart.svg?v=1757422731');

//     // Scroll handler
//     $(window).on('scroll', function () {
//       if ($(window).scrollTop() > 20) {
//         $header.addClass('header_scrolled');
//         $logo.attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo_dark.svg?v=1757364610');
//         $logo.attr('srcset', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo_dark.svg?v=1757364610');
//         $cart.attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/cart_dark.svg?v=1757422730');
//       } else {
//         $header.removeClass('header_scrolled');
//         $logo.attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo.svg?v=1757364310');
//         $logo.attr('srcset', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/datefix_logo.svg?v=1757364310');
//         $cart.attr('src', 'https://cdn.shopify.com/s/files/1/0780/1389/0866/files/cart.svg?v=1757422731');
//       }
//     });
//   }
// });

$(document).ready(function () {
    $('.menu-toggler , .mobile-overlay').click(function (e) { 
      e.preventDefault();
      $('body').toggleClass('mobile-sidebar-show');
    });
  });

  $(document).ready(function() {
  const overlay = document.getElementById('zoomOverlay');
  const zoomedImg = document.getElementById('zoomedImage');

  // 1. Listen for clicks on images inside the main carousel
  $('.carousel-main').on('click', '.carousel-cell img', function() {
    const src = $(this).attr('src');
    
    // Optional: If your images have a higher-res version, 
    // you can manipulate the URL string here to load the larger image.
    zoomedImg.src = src; 
    overlay.classList.add('active');
    
    // Prevent body scrolling while zoomed
    document.body.style.overflow = 'hidden';
  });

  // 2. Close overlay when clicked anywhere
  overlay.addEventListener('click', () => {
    overlay.classList.remove('active');
    document.body.style.overflow = 'auto';
  });
});